import { render, staticRenderFns } from "./addBranch.vue?vue&type=template&id=ff3846f8&"
import script from "./addBranch.vue?vue&type=script&setup=true&lang=js&"
export * from "./addBranch.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports